import { render, staticRenderFns } from "./resetTrade.vue?vue&type=template&id=db2d46a8"
import script from "./resetTrade.vue?vue&type=script&lang=js"
export * from "./resetTrade.vue?vue&type=script&lang=js"
import style0 from "./resetTrade.vue?vue&type=style&index=0&id=db2d46a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports